<template>

    <label 
        :for="inputEl"
        class="rw-custom-checkbox"
        :class="cssClasses">
        <input
            :id="inputEl"
            class="rw-custom-checkbox__input"
            type="checkbox"
            v-bind:checked="checked"
            v-on:change="$emit('change', Boolean($event.target.checked))"
        >
        <span class="rw-custom-checkbox__control-indicator">
          <template v-if="cssClasses && cssClasses.indexOf('active') !== -1">
            <i class="fal fa-minus"></i>
          </template>
        </span>
        <span class="rw-custom-checkbox__label" :class="{ 'sr-only': hideLabel }">{{label}}</span>
    </label>
</template>

<script>
export default {
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        inputEl: String,
        label: String,
        checked: Boolean,
        cssClasses: String,
        hideLabel: {
          type: Boolean,
          default: false
        }
    },
    watch: {
        checked(){
            // console.log(this.inputEl + ', ', typeof this.checked);
        }
    }
};
</script>